import {
  GET_CASE_PAPER_DATA_REQUEST,
  GET_CASE_PAPER_DATA_SUCCESS,
  GET_CASE_PAPER_DATA_FAILURE,
  CLEAR_CASE_PAPER_DATA,
} from "../actions/CasePaperTypes";

const initialState = {
  // Loading states
  loading: false,
  error: null,

  // Case paper data
  casePaperData: null,
  patientId: null,

  // Individual data sections (for backward compatibility)
  patient: null,
  appointments: [],
  prescriptions: [],
  reports: [],
  notes: [],
  panchakarma: [],
  counsellor: [],
  medical: [],
  followupCalls: [],
  questionnaires: [],
  statistics: {},
  platform: {},
};

const casePaperReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CASE_PAPER_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        patientId: action.payload?.patientId || null,
      };

    case GET_CASE_PAPER_DATA_SUCCESS:
      const { data, patientId } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        patientId,
        casePaperData: data,

        // Extract individual sections for backward compatibility
        patient: data?.patient || null,
        appointments: data?.appointments || [],
        prescriptions: data?.prescriptions || [],
        reports: data?.reports || [],
        notes: data?.notes || [],
        panchakarma: data?.panchakarma || [],
        counsellor: data?.counsellor || [],
        medical: data?.medical || [],
        followupCalls: data?.followupCalls || [],
        questionnaires: data?.questionnaires || [],
        statistics: data?.statistics || {},
        platform: data?.platform || {},
      };

    case GET_CASE_PAPER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.error || "Failed to fetch case paper data",
        patientId: action.payload?.patientId || null,
      };

    case CLEAR_CASE_PAPER_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default casePaperReducer;
